import type { JSX } from 'react';

import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';
import { Box } from '@change-corgi/design-system-legacy/layout';

import { LazyComponent } from 'src/app/shared/components/layout/lazy';

import type { PhoneCollectionWrapper } from './PhoneCollectionWrapper';

async function loadPhoneCollectionStep(): Promise<typeof PhoneCollectionWrapper> {
	return (
		await import(/* webpackChunkName: "pages/start-a-petition-steps-phone-collection" */ './PhoneCollectionWrapper')
	).PhoneCollectionWrapper;
}

export function PhoneCollectionLoader(): JSX.Element {
	return (
		<LazyComponent
			loadComponent={loadPhoneCollectionStep}
			fallback={
				<Box margin="auto">
					<Loader />
				</Box>
			}
		/>
	);
}

export const preloadPhoneCollectionStep = loadPhoneCollectionStep;
